import React, { ReactElement } from 'react'
import Admin from './Admin'
import Snippets from './Snippets'
import UserSettings from './UserSettings'
import { useLocation } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSyncAlt, faCog, faQuestionCircle, faExclamationTriangle, faCheckCircle,
    faRocket, faHistory, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import SettingsContextProvider from '../contexts/SettingsContext'
library.add(faSyncAlt, faCog, faQuestionCircle, faExclamationTriangle, faCheckCircle,
    faRocket, faHistory, faExternalLinkAlt)

const SettingsPage = (): ReactElement =>
    <SettingsContextProvider>
        <SettingsPageContents />
    </SettingsContextProvider>

const SettingsPageContents = (): ReactElement => {
    const path = useLocation().pathname
    const contents = path.startsWith('/admin')
        ? <Admin />
        : path.startsWith('/settings/snippets')
            ? <Snippets />
            : <UserSettings />
    return <div className="page settings-page">{ contents }</div>
}

export default SettingsPage
